// eslint-disable-next-line
import React from 'react';
import { Field, useField } from 'formik';
import { RGX_ONLY_NUMBERS, withNamespace } from 'utils/helpers';
import { AreaCodeField } from 'core/phones';
import { CustomTextField, InputWrapper } from 'components/forms';

import dictionary from 'utils/dictionary';
import PhoneCompanySelector from './PhoneCompanySelector';
import PhoneTypeSelector from './PhoneTypeSelector';
import { PhoneTypes } from './phone-type.model';
import { useGetCompanyFromNumber } from './hooks';

const fields = {
  PHONE_TYPE: 'phoneType',
  AREACODE: 'areaCode',
  PHONE_NUMBER: 'phoneNumber',
  PHONE_COMPANY: 'phoneCompany',
};

type Props = { namespace?: string; showErrorOnMount?: boolean };
const PhoneFields = ({ namespace = '', showErrorOnMount }: Props) => {
  const [phoneTypeField] = useField(
    withNamespace(namespace, fields.PHONE_TYPE)
  );
  const [areaCodeField] = useField(withNamespace(namespace, fields.AREACODE));
  const [phoneNumberField] = useField(
    withNamespace(namespace, fields.PHONE_NUMBER)
  );
  const [phoneCompanyField] = useField(
    withNamespace(namespace, fields.PHONE_COMPANY)
  );

  const fullPhone = areaCodeField.value + phoneNumberField.value;
  const { data: companyNumberData } = useGetCompanyFromNumber(fullPhone);

  const isClaro = companyNumberData?.number === fullPhone;

  return (
    <>
      <InputWrapper width="120px">
        <Field
          showErrorOnMount={showErrorOnMount}
          id={phoneTypeField.name}
          name={phoneTypeField.name}
          component={PhoneTypeSelector}
        />
      </InputWrapper>
      <InputWrapper width="100px">
        <Field
          showErrorOnMount={showErrorOnMount}
          id={areaCodeField.name}
          name={areaCodeField.name}
          component={AreaCodeField}
        />
      </InputWrapper>
      <InputWrapper width="160px">
        <Field
          showErrorOnMount={showErrorOnMount}
          id={phoneNumberField.name}
          name={phoneNumberField.name}
          label={dictionary.clientForm_label_phoneNumber}
          regex={RGX_ONLY_NUMBERS}
          component={CustomTextField}
        />
      </InputWrapper>
      <InputWrapper width="200px">
        <Field
          showErrorOnMount={showErrorOnMount}
          id={phoneCompanyField.name}
          name={phoneCompanyField.name}
          component={PhoneCompanySelector}
          isClaro={isClaro}
          disabled={
            !phoneTypeField.value || phoneTypeField.value === PhoneTypes.Fijo
          }
        />
      </InputWrapper>
    </>
  );
};

export const phoneFields = fields;

export default PhoneFields;
